import { type RefObject, useCallback, useEffect, useState } from 'react';

export const useActive = (ref: RefObject<HTMLElement | null>) => {
  const [isActive, setActive] = useState(false);

  const onPressIn = useCallback(() => {
    setActive(true);
  }, []);

  const onPressOut = useCallback(() => {
    setActive(false);
  }, []);

  useEffect(() => {
    const node = ref.current;

    node?.addEventListener?.('mousedown', onPressIn);
    node?.addEventListener?.('mouseup', onPressOut);

    return () => {
      node?.removeEventListener?.('mousedown', onPressIn);
      node?.removeEventListener?.('mouseup', onPressOut);
    };
  }, [ref, onPressIn, onPressOut]);

  return isActive;
};
